import React from 'react'
import {
    Table,
    OverlayTrigger,
} from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import VendorsLodingSkeleton from './table__loadingSkeleton'
import { renderTooltipDelete, renderTooltipEdit } from '../tooltips/Vendors__Tooltips'

export default function VendorsTable(props) {

    return (
        <Table responsive className="mb-0">
            <thead>
                <tr>
                    <th width={35}>
                        <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                            <input
                                type="checkbox"
                                className="d-none"
                                checked={props.allCheckboxSelected}
                                onChange={ev => props.handleSelectAllChange(ev)} />
                            <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                <FeatherIcon
                                    icon="check"
                                    size="11"
                                    className="icon position-relative" />
                            </span>
                        </label>
                    </th>
                    {
                        props.column__vendorName && (
                            <th>
                                <p className="text-capitalize">
                                    first name
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__companyName && (
                            <th>
                                <p className="text-capitalize">
                                    company name
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__email && (
                            <th>
                                <p className="text-capitalize">
                                    email
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__phone && (
                            <th>
                                <p className="text-capitalize">
                                    phone
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__businessLicenceNumber && (
                            <th>
                                <p className="text-capitalize">
                                    licence number
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__status && (
                            <th>
                                <p className="text-capitalize">
                                    zipcode
                                </p>
                            </th>
                        )
                    }

                    <th width="90"></th>
                </tr>
            </thead>

            <tbody>
                {
                    /* loading */
                    props.loading && (
                        <React.Fragment>
                            {
                                (props.loadingCount && props.loadingCount.length) && props.loadingCount.map(item => (
                                    <React.Fragment key={item}>
                                        <VendorsLodingSkeleton />
                                    </React.Fragment>
                                ))
                            }
                        </React.Fragment>
                    )
                }

                {
                    /* EMAILS DATA */
                    (props.vendors && props.vendors.length) ? props.vendors.map(item => (
                        <tr key={item.vendor_id}>
                            <td className="column__checkbox">
                                <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                    <input type="checkbox" className="d-none all-checkboxes-selector-checkbox" />
                                    <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                        <FeatherIcon
                                            icon="check"
                                            size="11"
                                            className="icon position-relative" />
                                    </span>
                                </label>
                            </td>

                            {
                                props.column__vendorName && (
                                    <td className="column__vendorName">
                                        <p className="">
                                            {item.first_name}{" "}{item.last_name}
                                        </p>
                                    </td>
                                )
                            }

                            {
                                props.column__companyName && (
                                    <td className="column__companyName">
                                        <p className="">
                                            {item.company_name}
                                        </p>
                                    </td>
                                )
                            }

                            {
                                props.column__email && (
                                    <td className="column__email">
                                        <p className="">
                                            {item.email}
                                        </p>
                                    </td>
                                )
                            }

                            {
                                props.column__phone && (
                                    <td className="column__phone">
                                        <p className="">
                                            {item.phone}
                                        </p>
                                    </td>
                                )
                            }

                            {
                                props.column__businessLicenceNumber && (
                                    <td className="column__businessLicenceNumber">
                                        <p className="">
                                            {item.license_number}
                                        </p>
                                    </td>
                                )
                            }

                            {
                                props.column__status && (
                                    <td className="column__status">
                                        <p className="">
                                            {item.zipcode}
                                        </p>
                                    </td>
                                )
                            }

                            <td className="column__actions">
                                <div className="d-flex justify-content-end">
                                    <OverlayTrigger
                                        placement={"left"}
                                        overlay={renderTooltipEdit}
                                    >
                                        <Link
                                            to={{
                                                pathname: '/catalog/vendors/edit/' + item.vendor_id,
                                                state: { vendorDetails: item }
                                            }}
                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center me-1"
                                        >
                                            <FeatherIcon
                                                icon="edit-2"
                                                size="15"
                                                className="icon" />
                                        </Link>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                        placement={"left"}
                                        overlay={renderTooltipDelete}
                                    >
                                        <button
                                            className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center"
                                            onClick={ev => props.handleDelete(ev, item.vendor_id)}
                                        >
                                            <FeatherIcon
                                                icon="trash"
                                                size="15"
                                                className="icon" />
                                        </button>
                                    </OverlayTrigger>
                                </div>
                            </td>
                        </tr>
                    )) : (
                        !props.loading ? (
                            <tr>
                                <td colSpan="7">
                                    <p className="no-data-found text-center st-fw-700 py-1">
                                        no data found
                                    </p>
                                </td>
                            </tr>
                        ) : null
                    )
                }
            </tbody>
        </Table>
    )
}
